import React, { useState } from 'react';
import { Button } from 'reactstrap';
import OnboardDetail from './OnboardDetail';
export default function DetailButton({
  id, LoadGroups
}) {
  const [isUpdating, setIsUpdating] = useState(false);

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Detail
      </Button>
      {isUpdating && (
        <OnboardDetail
          groupId={id}
          visible={isUpdating}
          LoadGroups={LoadGroups}
          toggle={() => setIsUpdating(!isUpdating)}
        />
      )}
    </div>
  );
}
